<template>
    <section >
       <b-card no-body class="dashboard-info-box ">
        <div class="info">
            <h5 class="title mb-50">{{title}}</h5>
            <h2 class="amount colorRed mb-2">{{amount}}</h2>
            <p class="update-text">{{updateText}}</p>
        </div>
        <img class="" src="@/assets/images/logo/Subtract.svg"/>
       </b-card>
    </section>
  </template>
        
<script>
  import {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import store from "@/store";
  import { ref, onUnmounted } from "@vue/composition-api";
  import dashboardStoreModule from "../dashboardStoreModule";
  
  export default {
    components: {
      BCard,
      BCardBody,
      BRow,
      BCol,
      BFormGroup,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      vSelect,
    },
    data() {
      return {};
    },
    props:{
        title: {
            type: String,
            required: true,
        },
        amount: {
            type: Number,
            required: false,
        },
        image_path: {
            type: String,
            required: true,
        },
        updateText: {
            type: String,
            required: true,
        },
    },
    computed:{ 
        image_src(){
            return process.env.VUE_APP_IMAGE_URL + this.image_path
        }
    },
    methods: {
    },
    setup() {

    },
  };
  </script>
        
  <style lang="scss" scoped>
  .dashboard-info-box{
    position: relative;
    background-color:#b7c1cf;
    margin-bottom:0px;
    
    .update-text{
        color:#c6c6c6
    }
    .info{
        position: absolute;
        top:2.5rem;
        left:2.5rem;
        // aspect-ratio: 1/1;
    }
    img{
        // width:300px;
    }
  }
  </style>
        
    <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@/assets/scss/variables/_variables.scss";
  </style>
        